var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll.self",
          value: _vm.hideDateRange,
          expression: "hideDateRange",
          modifiers: { self: true },
        },
      ],
      ref: "filterItem",
      class: [_vm.$.filter_item, _vm.isDate ? "filter_item_date" : ""],
    },
    [
      _vm.filterItem.template === "input"
        ? _c(
            "div",
            {
              class: [
                _vm.$.input,
                _vm.readonly ? _vm.$.input_without_padding : "",
              ],
              on: { click: _vm.clickDateInput },
            },
            [
              _c("vgp-input", {
                ref: "input",
                attrs: {
                  placeholder: _vm.filterItem.placeholder,
                  readonly: _vm.readonly,
                  "disabled-input-only": _vm.isDate,
                  value: _vm.inputValue,
                  small: true,
                  "icons-left": _vm.textInputIconsLeft,
                  "icons-right": _vm.textInputIconsRight,
                },
                on: { input: _vm.onInput },
                model: {
                  value: _vm.inputValue,
                  callback: function ($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("vgp-date-range-picker", {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.clickOutsideDateRange,
            expression: "clickOutsideDateRange",
          },
        ],
        attrs: {
          "is-range": true,
          show: _vm.isShowDateRange,
          "range-data": _vm.rangeValue,
          "target-element": _vm.dateRangeTarget,
          "presets-type": _vm.presetsTypeByFilterType,
        },
        on: { onChange: _vm.changeDateRange, onClose: _vm.hideDateRange },
      }),
      _vm._v(" "),
      _vm.isMultiInputItem && _vm.readonly
        ? _c("div", [
            _c(
              "div",
              {
                class: [_vm.$.input, _vm.$.input_without_padding],
                style: { marginBottom: "8px" },
              },
              [
                _c("div", {
                  class: _vm.$.readonly_text,
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.multiInputValues.start.value +
                        " &#8212; " +
                        _vm.multiInputValues.end.value
                    ),
                  },
                }),
              ]
            ),
          ])
        : _vm.isMultiInputItem
        ? _c("div", [
            _c(
              "div",
              {
                class: [
                  _vm.$.input,
                  _vm.readonly ? _vm.$.input_without_padding : "",
                ],
                style: { marginBottom: "8px" },
              },
              [
                _c("vgp-input", {
                  ref: "input",
                  attrs: {
                    placeholder: _vm.locales(
                      "filter_number_type_custom_column_from"
                    ),
                    readonly: _vm.readonly,
                    value: _vm.multiInputValues.start.value,
                    small: true,
                    "icons-left": _vm.textInputIconsLeft,
                    "input-type": _vm.isCustomNumberProp ? "number" : "text",
                  },
                  on: {
                    onChange: function ($event) {
                      return _vm.onChangeMultiInput(
                        _vm.multiInputValues.start.prop,
                        $event.target.value
                      )
                    },
                  },
                  model: {
                    value: _vm.multiInputValues.start.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.multiInputValues.start, "value", $$v)
                    },
                    expression: "multiInputValues.start.value",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  _vm.$.input,
                  _vm.readonly ? _vm.$.input_without_padding : "",
                ],
              },
              [
                _c("vgp-input", {
                  ref: "input",
                  attrs: {
                    placeholder: _vm.locales(
                      "filter_number_type_custom_column_to"
                    ),
                    readonly: _vm.readonly,
                    value: _vm.multiInputValues.end.value,
                    small: true,
                    "icons-left": _vm.textInputIconsLeft,
                    "input-type": _vm.isCustomNumberProp ? "number" : "text",
                  },
                  on: {
                    onChange: function ($event) {
                      return _vm.onChangeMultiInput(
                        _vm.multiInputValues.end.prop,
                        $event.target.value
                      )
                    },
                  },
                  model: {
                    value: _vm.multiInputValues.end.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.multiInputValues.end, "value", $$v)
                    },
                    expression: "multiInputValues.end.value",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.filterItem.template === "dropdown"
        ? _c(
            "div",
            { class: _vm.$.dropdown },
            [
              _c("dropdown-select", {
                attrs: {
                  readonly: _vm.readonly,
                  "drop-list": _vm.filterItem.options,
                  "use-color-palette": _vm.isTaskColorProp,
                  placeholder: _vm.placeholder,
                  multiselect: _vm.hasMultiselect,
                  "use-search": _vm.hasSearch,
                  "use-select-all": _vm.hasSelectAll,
                  "show-selected-first": false,
                  "show-reset-btn": true,
                  "highlight-active-state": false,
                  "item-template": _vm.chipTemplate,
                  "track-by-text": "value",
                  "drop-position": "fixed",
                  "group-by": "group",
                  "track-by-icon-name": "icon",
                  "track-by-bg-color": "color",
                  outline: _vm.readonly ? "none" : "always",
                  "popup-max-height": 200,
                  selected: _vm.dropdownValue,
                },
                on: { change: _vm.changeOptions },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.filterItem.template === "switch"
        ? _c(
            "div",
            { class: _vm.$.toggle },
            [
              _c(
                "div",
                {
                  class: [
                    _vm.$.label,
                    _vm.readonly ? _vm.$.label__readonly : "",
                  ],
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.readonly
                          ? _vm.locales("common_yes")
                          : _vm.filterItem.label
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.readonly
                ? _c("square-toggle", {
                    attrs: { "is-toggle-on": _vm.switchValue },
                    on: {
                      onChange: function ($event) {
                        return _vm.onChangeToggle(!_vm.filterItem.value)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }